import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppFeature } from './app-feature';
import { environment } from 'src/environments/environment';
import { globalVar } from 'src/app/shared/global_variables';
import { HttpClient } from '@angular/common/http';

export const APP_FEATURE = '/appFeature';
export const GET_ALL_FEATURES = '/getAllFeatures';

@Injectable({
    providedIn: 'root'
})
export class AppFeatureService {
    constructor(private httpClient: HttpClient) {}

    public getAllFeatures(): Observable<AppFeature[]> {
        return this.httpClient.get<AppFeature[]>(environment.baseUrl + globalVar.requestPrefix + APP_FEATURE + GET_ALL_FEATURES);
    }
}
